import { FC } from 'react';

interface OpenSliderProps {
  title: string; subtitle: string; show: boolean; content: FC<{}>; dispatch: any;
}
export function handleDispatchOpenSlider(
  { title, subtitle, show, content, dispatch }: OpenSliderProps) {

  dispatch({
    type: 'OPEN_SLIDER',
    data: {
      title: title,
      subtitle: subtitle,
      show: show,
      content: content,
    }
  });
}

export enum SlideStatusEnum {
  SLIDE_WARNING = 0,
  SLIDE_SUCCESS = 1
}